import PropTypes from 'prop-types';
import usePageMeta from 'src/hooks/usePageMeta';

// Enveloppe une route dans router.js pour lui donner ses balises SEO sans
// toucher au composant de la page : <PageMeta {...PAGE_META.about}><About /></PageMeta>.
const PageMeta = ({ title, description, path, noindex, children }) => {
  usePageMeta({ title, description, path, noindex });
  return children;
};

PageMeta.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  path: PropTypes.string,
  noindex: PropTypes.bool,
  children: PropTypes.node.isRequired
};

// Titres et descriptions en anglais, comme sur les autres sites CliClaim.
// Adresses officielles en minuscules (le routeur ignore la casse : /Signup et
// /signup affichent la même page).
const suffix = ' | CliClaim';
export const PAGE_META = {
  home: { path: '/' },
  signup: {
    path: '/signup',
    title: 'Create a customer account' + suffix,
    description:
      'Create your free CliClaim customer account to submit complaints and follow their resolution with restaurants, hotels and leisure businesses.'
  },
  about: {
    path: '/about',
    title: 'About CliClaim' + suffix,
    description:
      'CliClaim simplifies communication between customers and restaurants, hotels and leisure businesses to resolve complaints quickly.'
  },
  terms: {
    path: '/terms',
    title: 'Terms of Use' + suffix,
    description: 'Terms of use of the CliClaim customer space.'
  },
  privacy: {
    path: '/privacy',
    title: 'Privacy Policy' + suffix,
    description:
      'How CliClaim collects, uses and protects the personal data of its customers.'
  },
  // Pages de compte et espace connecté : accessibles, hors des résultats.
  forgotPassword: { title: 'Forgot password' + suffix, noindex: true },
  resetPassword: { title: 'Reset password' + suffix, noindex: true },
  privateArea: { noindex: true }
};

export default PageMeta;
